import LazyLoaderErrorBoundary from '@components/Errors/LazyLoaderErrorBoundary';
export default async function Loadable() {
    const { AssessmentStatusError } = await import('./index');
    return {
        Component: AssessmentStatusError,
        ErrorBoundary: LazyLoaderErrorBoundary,
    };
}
